import { APIClient } from "./axiosClient";
import { ResponseData } from "./types/_public";
import { AxiosResponse } from "axios";
import { IUser } from "./types/_user";
const api = new APIClient();

const path = "/users";
const userApi = {
  users(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  getUser(
    id: string | number,
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<IUser>, any>> {
    const url = `${path}/${id}`;
    return api.get(url, params);
  },

  postUser(dataForm: any): Promise<AxiosResponse<ResponseData<IUser>, any>> {
    const url = `${path}`;
    return api.post(url, dataForm);
  },

  putUser(
    id: string | number,
    dataForm: any
  ): Promise<AxiosResponse<ResponseData<IUser>, any>> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm);
  },

  deleteUser(id: any) {
    return api.delete(`${path}/${id}`);
  },

  putProfiles(dataForm: any): Promise<AxiosResponse<ResponseData<IUser>, any>> {
    const url = `${path}/profiles`;
    return api.put(url, dataForm);
  },

  getRegionsUser(params: any): Promise<any> {
    const url = `${path}/region`;
    return api.get(url, params);
  },

  getWorkHistoryByUser(
    userID: string | number,
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<IUser>, any>> {
    const url = `${path}/${userID}`;
    return api.get(url, {
      params
    });
  },

  getAppliedHistoryByUser(
    userID: string | number,
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<IUser>, any>> {
    const url = `${path}/${userID}/audition-applications`;
    
    return api.get(url, params);
  },

  getCountries(params: any): Promise<any> {
    const url = `${path}/countries`;
    return api.get(url, params);
  },

  putProfileUser(
    id: string | number,
    dataForm: any
  ): Promise<AxiosResponse<ResponseData<IUser>, any>> {
    const url = `${path}/${id}/profile`;
    return api.put(url, dataForm);
  },

};

export default userApi;
